import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotifications } from '@module/mdrt-org/shared/components/providers/notifications-context';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { type UserNotificationsDTO } from '@module/mdrt-org/shared/utils/data/get-user-notifications';
import { postMultipleUserNotificationStatusUpdate } from '@module/mdrt-org/shared/utils/data/post-multiple-user-notification-status-update';
import { Button } from '@shared/ui-components/button/button';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import DoubleCheckmarkIcon from '@shared/ui-components/svgs/double-checkmark-icon';
import styles from './mark-all-as-read-button.module.scss';
export const MarkAllAsReadButton = t0 => {
  const $ = _c(20);
  const {
    isSmall: t1
  } = t0;
  const isSmall = t1 === undefined ? true : t1;
  const {
    accessToken,
    personId
  } = useUserContext();
  const {
    allNotificationsAreRead,
    cmsContent,
    notifications,
    notificationsQueryKey
  } = useNotifications();
  const queryClient = useQueryClient();
  let t2;
  if ($[0] !== accessToken || $[1] !== personId) {
    t2 = async t3 => {
      const {
        upToNotificationId
      } = t3;
      return postMultipleUserNotificationStatusUpdate({
        accessToken,
        personId,
        upToNotificationId
      });
    };
    $[0] = accessToken;
    $[1] = personId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["mark-notification-as-read"];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] !== notificationsQueryKey || $[5] !== queryClient) {
    t4 = (_error, _variables, context) => {
      if (context?.previousNotificationsQueryData) {
        queryClient.setQueryData(notificationsQueryKey, context.previousNotificationsQueryData);
      }
    };
    t5 = async () => {
      await queryClient.cancelQueries({
        queryKey: notificationsQueryKey
      });
      const previousNotificationsQueryData = queryClient.getQueryData(notificationsQueryKey);
      queryClient.setQueryData(notificationsQueryKey, _temp2);
      return {
        previousNotificationsQueryData
      };
    };
    $[4] = notificationsQueryKey;
    $[5] = queryClient;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      mutationFn: t2,
      mutationKey: t3,
      onError: t4,
      onMutate: t5
    };
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    mutate: markMultipleNoticifationsAsRead
  } = useMutation(t6);
  let t7;
  if ($[12] !== markMultipleNoticifationsAsRead || $[13] !== notifications[0]?.id) {
    t7 = () => markMultipleNoticifationsAsRead({
      upToNotificationId: notifications[0]?.id
    });
    $[12] = markMultipleNoticifationsAsRead;
    $[13] = notifications[0]?.id;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== allNotificationsAreRead || $[16] !== cmsContent.markAllAsReadButtonLabel || $[17] !== isSmall || $[18] !== t7) {
    t8 = <Button aria-label={cmsContent.markAllAsReadButtonLabel} className={styles["mark-all-as-read-button"]} disabled={allNotificationsAreRead} Icon={DoubleCheckmarkIcon} isSmall={isSmall} onClick={t7} title={cmsContent.markAllAsReadButtonLabel} variant={ButtonVariant.Plain}>Mark all as read</Button>;
    $[15] = allNotificationsAreRead;
    $[16] = cmsContent.markAllAsReadButtonLabel;
    $[17] = isSmall;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function _temp(notification) {
  return {
    ...notification,
    isRead: true
  };
}
function _temp2(previousNotifications) {
  return {
    ...previousNotifications,
    notifications: previousNotifications?.notifications.map(_temp) ?? [],
    totalCount: previousNotifications?.totalCount ?? 0,
    unreadCount: 0
  };
}